import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./calendar.script";
export function RuiCalendar({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-calendar", {
    ...props,
    children
  });
}